export default __webpack_public_path__ + "static/media/Dusk in Mondstadt.85cbb7c3.mp3";